import type { GridProps } from '@chakra-ui/react'
import { forwardRef, Grid, Stack } from '@chakra-ui/react'
import type { Offer } from 'BrokerTsLib/src/dtos'

import type { InsuranceQuoteGroupFooterProps } from './InsuranceQuoteGroupFooter'
import { InsuranceQuoteGroupFooter } from './InsuranceQuoteGroupFooter'
import type { InsuranceQuoteGroupHeaderProps } from './InsuranceQuoteGroupHeader'
import {
  InsuranceQuoteGroupHeader
} from './InsuranceQuoteGroupHeader'
import { InsuranceQuoteHightligted } from './InsuranceQuoteHightligted'

export interface InsuranceQuoteGroupProps extends GridProps {
  highlightedQuotesList?: Offer[]
  groupHeaderProps?: InsuranceQuoteGroupHeaderProps
  groupFooterProps?: InsuranceQuoteGroupFooterProps
  customFooter?: React.ReactNode
  extraOffersNode?: React.ReactNode
  showHeader?: boolean
  showFooter?: boolean
}

export const InsuranceQuoteGroup = forwardRef(
  (
    {
      children,
      sx,
      highlightedQuotesList,
      groupHeaderProps,
      groupFooterProps,
      extraOffersNode,
      showHeader = true,
      showFooter = true,
      customFooter,
      ...rest
    }: InsuranceQuoteGroupProps,
    ref,
  ) => {

    return (
      <Stack ref={ref} sx={{ gap: 8, ...sx, mt: showHeader ? 0 : 8 }} {...rest}>
        {showHeader && <InsuranceQuoteGroupHeader {...groupHeaderProps} />}

        {extraOffersNode && extraOffersNode}

        {!!highlightedQuotesList?.length && (
          <InsuranceQuoteHightligted quotes={highlightedQuotesList} />
        )}

        <Grid sx={{ gap: { base: 4, md: 8 } }}>{children}</Grid>

        {showFooter && groupFooterProps && <InsuranceQuoteGroupFooter {...groupFooterProps} />}

        {!!customFooter && customFooter}
      </Stack>
    )
  },
)
